import { render, staticRenderFns } from "./tabSetting.vue?vue&type=template&id=fbdff8a0&scoped=true"
import script from "./tabSetting.vue?vue&type=script&lang=js"
export * from "./tabSetting.vue?vue&type=script&lang=js"
import style0 from "./tabSetting.vue?vue&type=style&index=0&id=fbdff8a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbdff8a0",
  null
  
)

export default component.exports